import { MODEL_SWITCH, ResCode } from "logic/src/constants/request";

export enum AgreeType {
  userPrivacy = 1, //用户隐私
  infoCollect = 2, //信息收集
}

export enum ELoginType {
  "sms_code" = "sms_code",
  "password" = "password",
}

export interface IUserInfo {
  email: string;
  mobile: string;
  area: string;
  id: string;
  name: string;
  model_switch: MODEL_SWITCH;
  need_init_passwd: boolean;
}

export interface IBIndInfo {
  mobile: string;
  email: string;
  thirdparty: {
    platform: string;
    id: string;
  }[];
}

export type TVideoWhiteStatus = "applying" | "unauthorized" | "authorized";
